import { render } from "./Paper.vue?vue&type=template&id=7caacc88&scoped=true&ts=true"
import script from "./Paper.vue?vue&type=script&lang=ts"
export * from "./Paper.vue?vue&type=script&lang=ts"

import "./Paper.vue?vue&type=style&index=0&id=7caacc88&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caacc88"]])

export default __exports__